@import 'styles/mixins';

.keyActionButton {
  white-space: nowrap;
}

.typeReview {
  color: var(--action-60);
}

.typeReadReceipt {
  color: var(--focus-50);
}

.typeApproval {
  color: var(--action-60);
}

.typeSuggestion {
  color: var(--strong-50);
}
